module.exports = __webpack_public_path__ + "static/media/person_active.7cc218f3.svg";